var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('common-header',{attrs:{"data":['home', 'manage', 'manageFiles']}}),_c('div',{staticClass:"container-fluid"},_vm._l((_vm.sortedItems),function(folder,index){return _c('FolderItem',{key:index,attrs:{"item":folder,"downloadFile":_vm.downloadFile}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }